enum PendingRequest {
  CardLimit = "Card Limit",
  Merchant = "Merchant",
  NewCard = "New Card",
  LostStolen = "Lost/Stolen",
}

export default PendingRequest;
